import type { RootState } from 'store';

export const getReverseSizeGradiation = (state: RootState) =>
  state.settingsState.plantDisplay.reverseSizeGradiation;

export const getMetricType = (state: RootState) =>
  state.settingsState.metricType;

export const getAutoSimulate = (state: RootState) =>
  state.settingsState.autoSimulate;

export const getShowReportPanel = (state: RootState) =>
  !!state.unitConnGroup.present.unitState.activeUnit &&
  state.layout.showReportPanel;

export const getSettingsState = (state: RootState) => state.settingsState;

// Moved selectors:
// - getFileStatus -> store/fileState/selectors.ts
// - getProjectData -> store/documentMetadata/selectors.ts
